<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards path="/layout/list/walkIntroTianLi"></imgBigCards>
    <!-- 标题-->
    <!-- 内容 -->
    <div class="box-content">
      <div>
        <div class="one-title">
          <p>
            {{ mydata.articleInfo.title }}
            <!-- 学习顾问课程规划师 -->
          </p>
          <P>
            <span style="margin-right: 34px">
              发表时间：
              {{
                dayjs(mydata.articleInfo.release_time * 1000).format(
                  "YYYY-MM-DD"
                )
              }}
              <!-- 2023-11-07 -->
            </span>
            <span style="margin-right: 34px"
              >来源：{{ mydata.articleInfo.source }}</span
            >
            <span
              >关键词：
              <span
                v-for="(item, index) in mydata.articleInfo.tags"
                :key="index"
                style="margin-right: 10px"
                >{{ item.name }}</span
              >
            </span>
          </P>
        </div>
        <div class="one-content">
          <p class="tableA" v-html="mydata.articleInfo.content"></p>
          <!-- <p class="content-top">xxxxxxxx</p>
          <div class="detail-box">
            <p class="detail-title">工作职责</p>
            <p>1、负责考研及专升本课程的客户咨询，促成签单转化；</p>
            <p>2、积极维护现有客户关系，协助后期做好学员服务；</p>
            <p>3、完成月度/季度/年度各项业绩考核指标。</p>
          </div>
          <div class="detail-box">
            <p class="detail-title">任职资格</p>
            <p>1、大专及以上学历，有销售经验优先；</p>
            <p>2、有教育行业工作经验优先；</p>
            <p>3、沟通能力强、责任心强、良好的影响说服能力；</p>
            <p>4、团队合作精神良好，认同新东方企业文化。</p>
          </div>
          <div>
            <p class="detail-title">联系方式</p>
            <p>电话：010-51655511</p>
            <p>邮箱：1234567890000@qq.com</p>
          </div> -->
        </div>

        <div class="one-foot">
          <p
            style="cursor: pointer"
            @click="goPrevOrNext(mydata.articleInfo.prev.id)"
            v-if="mydata.articleInfo.prev?.title !== undefined"
          >
            上一篇：{{ mydata.articleInfo.prev?.title }}
          </p>
          <p
            style="cursor: pointer"
            @click="goPrevOrNext(mydata.articleInfo.next.id)"
            v-if="mydata.articleInfo.next?.title !== undefined"
          >
            下一篇： {{ mydata.articleInfo.next?.title }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Calendar } from "@element-plus/icons-vue";
import { View } from "@element-plus/icons-vue";
import { Download } from "@element-plus/icons-vue";
import { Menu } from "@element-plus/icons-vue";
import { Lock } from "@element-plus/icons-vue";

import { useRouter, useRoute } from "vue-router";

import dayjs from "dayjs";

import { reactive, watch } from "vue";
import { Star } from "@element-plus/icons-vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import inputBox from "@/components/inputBox/index.vue";

import column from "@/components/column/index.vue";

import rowBookCards from "@/components/rowBookCards/index.vue";

import activityResultsCard from "@/components/activityResultsCard/index.vue";

// 引入接口
import { articleInfo } from "@/api/home/index.js";

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  articleId: null, // 文章id值
  articleInfo: {}, // 文章详情

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  //  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //用户信息
});

// 监听路由完整地址
watch(
  () => {
    return route.fullPath;
  },
  (n, o) => {
    // 在watch中判断，如果当前的地址不是自己的页面对应的地址，那么就终止执行（解决缓存组件带来的问题）
    if (!n.includes("/layout/list/joinUsDetails")) {
      return;
    }
    init();
  },
  {
    immediate: true,
  }
);

// 初始化函数
function init() {
  // 获取到传递过来的参数
  mydata.articleId = route.query.id;
  // 调用接口获取文章详情
  articleInfo({ id: mydata.articleId }).then((res) => {
    // console.log(res);
    mydata.articleInfo = res.data;
    // 设置title标题
    window.document.getElementsByTagName("title")[0].innerHTML =
      mydata.articleInfo.title;
  });
}

// init();

function goPrevOrNext(id) {
  if (id === undefined) {
    return;
  }

  router.push({
    path: "/layout/list/joinUsDetails",
    query: { id },
  });
}
</script>

<style scoped lang="scss">
.books-details {
  background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //////内容部分
  .box-content {
    // width: 1200px;
    // border: 1px solid red;
    margin: 0 auto;
    background-color: #ffffff;
    padding: 16px 16px 20px 16px;
    .one-title {
      p:nth-of-type(1) {
        min-height: 28px;
        font-size: 18px;
        font-weight: 700;
        color: #333333;

        line-height: 28px;
        // height: 56px;
        display: -webkit-box;
        -webkit-box-orient: vertical; // 从上向下垂直排列子元素。设置或检索伸缩盒对象的子元素的排列方式 。
        text-overflow: ellipsis; //文本溢出 用省略号显示
        -webkit-line-clamp: 2; //几行
        overflow: hidden;
      }
       p:nth-of-type(2) {
        display: flex;
        flex-wrap:wrap;
        // border:1px solid red;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: #888888;
        margin-top: 12px;
        > span {
          margin-right: 34px;
        }
      }
    }
    ////内容部分
    .one-content {
      width: 343px;
      // height:1824px;
      // border: 1px solid blue;
      margin-top: 24px;
      // img {
      //   width: 720px;
      //   height: 480px;
      //   margin: 0 auto;
      //   display: block;
      //   // border:1px solid yellow;
      // }
      p {
        margin-top: 24px;
        white-space: pre-wrap;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        // color:red;
      }
    }

    .one-foot {
      width: 343px;
      // height: 84px;
      // border: 1px solid red;
      border-top: 1px dashed #cccccc;
      margin-top: 26px;
      p {
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        white-space: nowrap; //不折行
        text-overflow: ellipsis; //文本溢出 用省略号显示
        overflow: hidden;
      }
      p:nth-of-type(1) {
        margin-top: 24px;
      }
      p:nth-of-type(2) {
        margin-top: 16px;
      }
      p:hover {
        color: #009de0;
      }
    }

    // }
    //////右边
    // .box-right {
    //   width: 320px;
    //   // border:1px solid rgb(255, 174, 0);
    //   border-radius: 8px;
    //   .activity-results {
    //     width: 320px;
    //     .box-content img {
    //       width: 256px;
    //       height: 145px;
    //       border-radius: 8px;
    //       margin-bottom: 20px;
    //       display: block;
    //     }
    //     .box-content img:nth-last-of-type(1) {
    //       margin-bottom: 0px;
    //     }
    //   }
    // }
  }
}
</style>
